import { AfterContentInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgxExtendedPdfViewerService, PagesLoadedEvent } from 'ngx-extended-pdf-viewer';

@Component({
  selector: 'app-validation-matricula',
  templateUrl: './validation-matricula.component.html',
  styleUrls: ['./validation-matricula.component.css']
})
export class ValidationMatriculaComponent implements OnInit,AfterContentInit {
  public messages: Array<string> = [];
  pdfSource:string
  dimensionH:number
  _color:string = '#fff'
  folio:string
  @ViewChild('viewerContainer') visorPDF!: any;
  constructor(private route: ActivatedRoute,private pdfService: NgxExtendedPdfViewerService) { 
    this.pdfSource = ''
    this.folio = ''
    this.dimensionH = screen.height

  }
  
  ngOnInit(): void {
   
    console.log(screen.width)
    this.route.paramMap.subscribe({
      next:(params) =>{
        if(params.get('folio'))
         {
          this.folio = params.get('folio') as string
        // console.log(params.get('folio'))
        this.pdfSource = `/assets/${this.folio}_1.pdf`
         }

      },
    })
  }

  ngAfterContentInit(): void {

  }


  public onPagesLoaded(pagecount: PagesLoadedEvent): void {
    const now = new Date().toLocaleTimeString();
    this.messages.push(`${now} Loaded a document with ${pagecount.pagesCount} pages`);
    // console.log(this.messages)
  }

}
